module.exports = __webpack_public_path__ + "b04e58fb0609e38bef05644b61870f24.fbx";